import { type Signal } from '@angular/core'
import { injectQuery } from '@tanstack/angular-query-experimental'
import { injectCartoClient } from '../services/carto.helper'
import {
  fetchTrafficQuantiles,
  TrafficQuantilesRow,
} from '../services/traffic-quantiles.service'
import { type PoisFilters } from '../services/pois.service'

export { type TrafficQuantilesRow } from '../services/traffic-quantiles.service'

// Peach palette from CARTOColors
const TRAFFIC_COLORS = [
  '#fde0c5',
  '#facba6',
  '#f8b58b',
  '#f59e72',
  '#f2855d',
  '#ef6a4c',
  '#eb4a40',
]

const DEFAULT_STOPS = [
  [0, TRAFFIC_COLORS[0]],
  [100, TRAFFIC_COLORS[TRAFFIC_COLORS.length - 1]],
]

export function injectTrafficQuantilesQuery(filters: Signal<PoisFilters>) {
  const cartoClient = injectCartoClient()

  return injectQuery(() => ({
    // Key only on the fields fetchTrafficQuantiles uses, so target-filter
    // (columns), reach or tag changes don't trigger redundant refetches.
    queryKey: [
      'traffic-quantiles',
      filters().delivery_id,
      filters().delivery_start_date,
      filters().filter_combined,
    ],
    queryFn: async ({ signal }) => {
      return fetchTrafficQuantiles(cartoClient, filters(), signal)
    },
    select: (quantiles) => {
      if (!quantiles) {
        return DEFAULT_STOPS
      }

      const quantileKeys: (keyof TrafficQuantilesRow)[] = [
        'q1',
        'q2',
        'q3',
        'q4',
        'q5',
        'q6',
      ]

      return [
        [0, TRAFFIC_COLORS[0]],
        ...quantileKeys.map((key, i) => [
          quantiles[key],
          TRAFFIC_COLORS[i + 1],
        ]),
      ]
    },
    enabled: filters().delivery_id > 0,
  }))
}
